<template>
  <div v-if="isShow">
    <div class="ticket-group">
      <h2 class="ticket-toggle-main-tit" :tabindex="category.passgroup_type === 'voucher' ? 0 : ''">{{ category.passgroup_name }}</h2>
      <section v-for="(productGroup, index) in category.productgroups" :key="index">
        <ul class="voucher-list">
          <li v-for="(voucher, index) in productGroup.products" :key="'voucher_info_' + index">
            <div>
              <div class="label-area">
                <h3>
                  <span>{{ getValue(voucher, 'product_name') }}</span>
                  <span v-if="getValue(voucher, 'recommendation')" class="icon icon-supplant">추천</span>
                  <span v-if="getValue(voucher, 'in_use')" class="icon">이용중</span>
                </h3>

                <div v-if="category.passgroup_type !== 'voucher'" class="price-area">
                  <button type="button" @click="clickPurchase(voucher, getValue(voucher, 'productid'))"
                          :class="selectedProductId === getValue(voucher, 'productid', '') ? 'btn selected' : 'btn'">
                    {{category.passgroup_type !== 'voucher' ? `${getValue(voucher, 'use_day')} / ` : ''}}&#65510;{{ setNumberCommas(getValue(voucher, 'amount')) }}
                  </button>
                </div>
              </div>
              <table class="benefit-table" v-if="category.passgroup_type === 'voucher'">
                <caption>웨이브 이용권 표</caption>
                <colgroup>
                  <col style="width: 80px;">
                  <col>
                </colgroup>
                <tbody>
                <tr>
                  <th scope="row">동시시청</th>
                  <td>{{ getValue(voucher, 'concurrency_count') }}명</td>
                </tr>
                <tr>
                  <th scope="row">화질</th>
                  <td>{{ qualityText(getValue(voucher, 'quality')) }}</td>
                </tr>
                <tr>
                  <th scope="row">이용기기</th>
                  <td>{{ getValue(voucher, 'support_device') }}</td>
                </tr>
                </tbody>
              </table>

              <!-- 패키지 구매: 기존 소스 코드-->
              <div v-if="category.passgroup_type === 'package' && packageList(voucher) && packageList(voucher).length > 0" class="product-package">
                <ul>
                  <li v-for="(detail, index) in packageList(voucher)" :key="'package_info_' + index">
                <div class="product-package-img">
                  <div class="picture-area">
                    <WebpImage :imageInfo="{imageUrl: detail.image, width: 88, height: 132, alt: detail.title}" />
                  </div>
                </div>
                    <span class="product-package-title">
                  <span>{{ detail.title }}</span>
                </span>
                  </li>
                </ul>
              </div>

              <!-- D: 구매 버튼 2개 노출 시 -->
              <div class="button-area" v-if="category.passgroup_type === 'voucher'">
                <button type="button" @click="clickPurchase(voucher, getAmountInfoValue(amountInfoData, 'productid', ''))"
                        v-for="(amountInfoData, index) in purchaseAmountInfoList(voucher)"
                        :key="'wavve_voucher_head_' + index" :class="selectedProductId === getAmountInfoValue(amountInfoData, 'productid', '') ? 'btn selected' : 'btn'">
                  <span class="month">
                    <span>{{ getAmountInfoValue(amountInfoData, 'use_day') }}</span>
                    <span class="discount" v-if="getAmountInfoValue(amountInfoData, 'discount_rate') !== ''">{{ getAmountInfoValue(amountInfoData, 'discount_rate') }}%</span>
                  </span>
                  <span class="price">
                    <span>₩{{ setNumberCommas(getAmountInfoValue(amountInfoData, 'amount')) }}</span>
                    <span class="summary" v-if="isMonthAmount(amountInfoData)">(월 &#65510;{{ setNumberCommas(getAmountInfoValue(amountInfoData, 'month_amount')) }})</span>
                  </span>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </section>
      <p class="notice-message" v-if="category.passgroup_type === 'voucher'">매월 자동결제 / 부가세포함</p>
    </div>
  </div>
</template>

<script>
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'
import WebpImage from '@/components/image/WebpImage'

export default {
  components: { WebpImage },
  props: {
    category: {
      type: Object,
      required: true
    },
    packageDetailMap: {
      type: Object
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String
    }
  },
  data () {
    return {
      type: 'voucher',
      selectedProductId: ''
    }
  },
  computed: {
    isShow () {
      return this.category && _.get(this.category, 'productgroups', []).length > 0
    }
  },
  methods: {
    setNumberCommas (price) {
      return setNumberCommas(price)
    },
    clickPurchase (voucher, productId) {
      this.selectedProductId = productId
      let locationOrign = window.location.origin
      if (!locationOrign) {
        locationOrign = window.location.protocol + '//' + window.location.hostname
      }
      let returnUrl = locationOrign + '/callback.html?action=ClosePopupAndReload'

      window.location.href = constant.URL_BILLING_PAYMENT +
        '?credential=' + encodeURIComponent(cookie.getCredential()) +
        '&productId=' + encodeURIComponent(productId) +
        '&productType=all' +
        '&returnUrl=' + encodeURIComponent(returnUrl) +
        (this.contentType ? '&contentType=' + encodeURIComponent(this.contentType) : '') +
        (this.contentId ? '&contentid=' + encodeURIComponent(this.contentId) : '') +
        '&deviceTypeId=pc&marketTypeId=generic&partnerUserKey='
    },
    packageList (voucher) {
      if (_.get(this.category, 'passgroup_type', '') === 'package') {
        const productId = _.get(voucher, 'concurrency.0.productid', null)
        if (productId === null) return []
        return this.packageDetailMap[productId]
      } else {
        return []
      }
    },
    getValue (voucher, key) {
      return _.get(voucher, ['concurrency', '0', key], '')
    },
    purchaseAmountInfoList (voucher) {
      return _.get(voucher, 'concurrency.0.purchase_amount_info_list', [])
    },
    getAmountInfoValue (amountInfoData, key) {
      return _.get(amountInfoData, key, '')
    },
    qualityText (text) {
      return text.toUpperCase() === 'UHD' ? '최고 화질' : text + ' 화질'
    },
    isMonthAmount (amountInfoData) {
      return _.defaultTo(_.get(amountInfoData, 'month_amount', ''), '')
    }
  },
  created () {
    this.type = _.get(this.$route, ['query', 'type'], 'voucher')
  }
}
</script>
